export { default as Header } from './header';
export { default as SwitchItem } from './switchItem';
export { default as NavBar } from './navBar';
export { default as RkPayContent } from './rkpayContent';
